import { render, staticRenderFns } from "./salesRateManage.vue?vue&type=template&id=1d42da91&scoped=true"
import script from "./salesRateManage.vue?vue&type=script&lang=js"
export * from "./salesRateManage.vue?vue&type=script&lang=js"
import style0 from "./salesRateManage.vue?vue&type=style&index=0&id=1d42da91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d42da91",
  null
  
)

export default component.exports